import {FilenameUtil} from 'yougile-util'
import {systemStickers} from './constants'
import {DataObjectId} from './data-object'
import {Hub, HubJSON, isHub} from './hubs'
import {SystemMessageUtils} from './system-message-utils'

export class TaskDataService {
  public getTask: (id: DataObjectId) => Hub | HubJSON | undefined
  public isDeleted: (id: DataObjectId) => boolean
  public getStickerIds: () => typeof systemStickers

  constructor(
    getTask: (id: DataObjectId) => Hub | HubJSON | undefined,
    isDeleted: (id: DataObjectId) => boolean,
    getStickerIds: () => typeof systemStickers
  ) {
    this.getTask = getTask
    this.isDeleted = isDeleted
    this.getStickerIds = getStickerIds
  }

  private getMessages(task: Hub | HubJSON) {
    const clientMessageLimit = 1000
    const serverMessageLimit = 100
    return isHub(task)
      ? task.chat
          .getMessages()
          .map(x => {
            return x.text
          })
          .slice(-clientMessageLimit)
      : Object.values(task.chat?.messages ?? {})
          .filter(
            x => x && !x.deleted && !SystemMessageUtils.isSystemMessage(x)
          )
          .map(x => x.text)
          .slice(-serverMessageLimit)
  }

  private getMessagesAllTextWithFiles(id: DataObjectId): string {
    const task = this.getTask(id)
    if (!task) {
      return ''
    }
    return this.getMessages(task).join(' ')
  }

  getDescription(id: DataObjectId): string {
    const task = this.getTask(id)
    if (!task) {
      return ''
    }
    return task.description ?? ''
  }

  getMessagesAllText(id: DataObjectId): string {
    return FilenameUtil.removeFilenames(this.getMessagesAllTextWithFiles(id))
  }

  getFilenames(id: DataObjectId): string {
    return FilenameUtil.getFilenames(
      this.getMessagesAllTextWithFiles(id) + ' ' + this.getDescription(id)
    ).join(' ')
  }
}
